import React, { useState, useRef, useEffect, useCallback } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Row,
  Col,
  Input,
  Collapse,
  PageHeader,
  Button,
  Checkbox,
  AutoComplete,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
  threeColumnFormItemLayout,
} from "./../../utils/Layouts";
import {
  EditOutlined,
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  addNew,
  onSearch,
  onDeleteItem,
  onChange,
  onFinish,
  hasAccess,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SupplierFormModal from "../modals/SupplierFormModal";
import {
  onSupplierSearch,
  onStockSearch,
  addKeysToArray,
  onUnitSearch,
  onDepartmentSearch,
  onCompaniesSearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import axios from "axios";
import {
  PO_STATUS_PENDING,
  PO_STATUS_ACCOMPLISHED,
  PO_STATUS_CLOSED,
  APPROVED,
  USER_ADMINISTRATOR,
  TRANS_COMPARATIVE_SLIP,
  TRANS_PO_COMPARATIVE_SLIP,
  OPEN,
  CLOSED,
  FOR_QUOTATION,
  APPROVED_FOR_QUOTE,
  CLOSE_QUOTE,
  FOR_APPROVAL,
  PURCHASE_ORDER_GENERATED,
  SOCKET_ENDPOINT,
  CANCELLED,
  ACCESS_ADVANCE_SEARCH,
  COMPARATIVE_CLOSED,
  PENDING,
} from "../../utils/constants";
import { flattenDeep, sumBy, uniqueId, uniq } from "lodash";
import { Link, useLocation, useParams } from "react-router-dom";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import validator from "validator";

import ComparativeRecordButton from "./../../commons/ComparativeRecordButtons";

import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import FormButtons from "../../commons/FormButtons";
import UnitFormModal from "../modals/UnitFormModal";

import ItemsFields from "../../commons/ItemsField";
import Column from "antd/lib/table/Column";
import TextArea from "antd/lib/input/TextArea";
import ColumnGroup from "antd/lib/table/ColumnGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import FileSaver from "file-saver";
import ComparativeFormButtons from "../../commons/ComparativeFormButtons";
import socketIoClient from "socket.io-client";
import classnames from "classnames";

import StockFormModal from "../modals/StockFormModal";

const { Content } = Layout;
const { Panel } = Collapse;

const url = "/api/purchase-requests/";
const title = "Comparative Slip Form";

const initialValues = {
  _id: null,
  prq_no: null,
  date: moment(),
  date_needed: moment(),
  supplier: null,
  remarks: "",
  comparative_remarks: "",
  items: [],
};

const initialItemValues = {
  stock: null,
  quantity: null,
};

const date_fields = ["date", "date_needed"];
const transaction_counter = {
  label: "CN #",
  key: "cs_no",
};

const itemHasSelection = (item) => {
  for (let i = 0; i < item.quotations.length; i++) {
    if (item.quotations[i]?.is_selected || false) {
      return true;
    }
  }

  return false;
};

const itemHasPrice = (item, suppliers) => {
  if (item.quotations.length < suppliers.length) {
    return false;
  }

  const has_price =
    item.quotations.filter((o) => o.price > 0).length >= suppliers.length;

  return has_price;
};

const itemQuotationSelectedHasPrice = (item) => {
  return (
    item.quotations.filter(
      (o) => (o.price > 0 && o.quantity > 0 && o.is_selected) || !o.is_selected
    ).length >= item.quotations.length
  );
};

const eachItemHasPrice = (record) => {
  return (
    record.items.filter((item) => itemHasPrice(item, record.suppliers))
      .length >= record.items.length
  );
};

const eachCheckedQuotationHasPrice = (record) => {
  return (
    record.items.filter((item) => itemQuotationSelectedHasPrice(item)).length >=
    record.items.length
  );
};

const onSelectCanvas = ({
  line_item,
  checked,
  canvas_index,
  state,
  setState,
}) => {
  //check if item exists
  let selected_items = state.canvases[canvas_index]?.selected_items || [];

  //check if there item is found
  selected_items = selected_items.filter((o) => o._id !== line_item._id);

  if (checked) {
    selected_items = [
      ...selected_items,
      {
        ...line_item,
      },
    ];
  }

  let canvases = [...state.canvases];
  canvases[canvas_index].selected_items = selected_items;

  axios
    .post(`/api/purchase-requests/${state._id}/canvases`, {
      canvases,
    })
    .catch((err) =>
      message.error("There was an error processing your request")
    );

  setState((prevState) => ({
    ...prevState,
    canvases,
  }));
};

export default function ComparativeSlipForm({ match }) {
  const params = useParams();
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);

  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const socket = useRef(null);

  const [row_selected, setRowSelected] = useState(null);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
  });
  const [loading, setLoading] = useState(false);

  const [state, setState] = useState(initialValues);
  const [search_state, setSearchState] = useState({
    period_covered: [null, null],
    supplier: null,
    po_no: "",
    approval_status: APPROVED_FOR_QUOTE,
  });
  const [search, setSearch] = useState(true);

  const supplierFormModal = useRef(null);
  const unitFormModal = useRef(null);
  const departmentFormModal = useRef(null);
  const stockFormModal = useRef(null);
  const associateUnitOfMeasureStockModalRef = useRef(null);

  const suppliers_column = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record, index) => (
        <span>
          {state.comparative_slip_status?.approval_status ===
            APPROVED_FOR_QUOTE && (
            <DeleteOutlined
              onClick={() => {
                onDeleteItem({
                  field: "suppliers",
                  index,
                  setState,
                });

                let items = [...state.items];

                //remove quotation from suppliers
                items.forEach((item, index, arr) => {
                  const quotations = item.quotations.filter((quotation) => {
                    return quotation.supplier?._id !== record._id;
                  });
                  arr[index]["quotations"] = quotations;
                });

                setState((prevState) => ({
                  ...prevState,
                  items,
                }));
              }}
            />
          )}
        </span>
      ),
    },
  ];

  useEffect(() => {
    socket.current = socketIoClient(SOCKET_ENDPOINT);
    socket.current.on("refresh-comparative", () => {
      if (search) {
        onSearch({
          page: current_page,
          url: "/api/comparative-slips/",
          setRecords,
          setTotalRecords,
          setCurrentPage,
          setErrors,
          advance_search: { ...search_state },
          setSearch,
        });
      }
    });

    socket.current.on("refresh-purchase-request", ({ _id, name }) => {
      // console.log(_id, state._id, search);
      if (!search && _id?.toString() === state._id?.toString()) {
        //refresh when the request is open
        message.info(`${name} has modified the record`);
        axios
          .get(`/api/purchase-requests/${_id}`)
          .then((response) => {
            if (response.data) {
              edit({
                record: {
                  _id: _id,
                },
                setState,
                setErrors,
                setRecords,
                url: "/api/purchase-requests/",
                date_fields,
                other_state: {
                  purchase_request: {
                    ...response.data,
                  },
                },
                setSearch,
              });
            }
          })
          .catch((err) =>
            message.error("There was an error processing your request")
          );
      }
    });

    socket.current.on("prq-generated", (id) => {
      setRecords((prevRecords) => {
        const _records = [...prevRecords].filter((o) => o._id !== id);

        return _records;
      });
    });
    return () => {
      socket.current.close();
      socket.current.disconnect();
    };
  }, [current_page, search, search_state, setRecords]);

  useEffect(() => {
    onSupplierSearch({ value: "", options, setOptions });

    return () => {};
  }, []);

  useEffect(() => {
    onSearch({
      page: current_page,
      search_keyword,
      url: "/api/comparative-slips/",
      setRecords,
      setTotalRecords,
      setCurrentPage,
      setErrors,
      advance_search: { ...search_state },
    });

    return () => {};
  }, []);

  const record_buttons = (
    <ComparativeRecordButton
      setRecords={setRecords}
      url={url}
      auth={auth}
      row_selected={row_selected}
      state={records?.[row_selected]}
      onSearch={() => {
        setState(initialValues);
        setItem(initialItemValues);
        onSearch({
          page: current_page,
          search_keyword,
          url: "/api/comparative-slips/",
          setRecords,
          setTotalRecords,
          setCurrentPage,
          setErrors,
          advance_search: { ...search_state },
          setSearch,
        });
      }}
      onSendCanvas={(record) => {
        setState({
          ...initialValues,
          _id: null,
          purchase_request: { ...record },
          items: [...record.items],
          is_send_canvas: true,
          is_input_canvas: false,
        });
        setRecords([]);
        onSupplierSearch({ value: "", options, setOptions });
      }}
      onInputCanvas={(record) => {
        setState({
          ...initialValues,
          _id: null,
          purchase_request: { ...record },
          items: [...record.items],
          is_input_canvas: true,
          is_send_canvas: false,
          canvases: record.canvases,
        });
        setRecords([]);
      }}
      transaction="comparative-slips"
      can_close={
        records?.[row_selected]?.items.filter((o) => itemHasSelection(o))
          .length > 0
      }
      additional_buttons={[
        records?.[row_selected]?.alert_status !== "Alert" && false && (
          <span
            key="alert"
            className="button control is-danger is-outlined is-small m-l-1"
            onClick={() => {
              axios
                .post(
                  `/api/comparative-slips/${records?.[row_selected]._id}/alert-status`,
                  {
                    alert_status: "Alert",
                  }
                )
                .then(() => {
                  onSearch({
                    page: current_page,
                    search_keyword,
                    url: "/api/comparative-slips/",
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: { ...search_state },
                    setSearch,
                  });
                })
                .catch((err) => {
                  message.error("There was an error creating an alert");
                });
            }}
          >
            <span>Alert</span>
          </span>
        ),

        ["Alert", "Replied"].includes(
          records?.[row_selected]?.alert_status
        ) && (
          <span
            key="seen"
            className="button control is-outlined is-small m-l-1"
            onClick={() => {
              axios
                .post(
                  `/api/comparative-slips/${records?.[row_selected]._id}/alert-status`,
                  {
                    alert_status: "Seen",
                  }
                )
                .then(() => {
                  onSearch({
                    page: current_page,
                    search_keyword,
                    url: "/api/comparative-slips/",
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: { ...search_state },
                    setSearch,
                  });
                })
                .catch((err) => {
                  message.error("There was an error creating an alert");
                });
            }}
          >
            <span>Cancel Alert</span>
          </span>
        ),
      ]}
    />
  );

  return (
    <Content className="content-padding">
      <SupplierFormModal
        setField={(supplier) => {
          let items = [...state.items];
          items.forEach((item, index, arr) => {
            let quotations = item?.quotations || [];

            quotations = [
              ...quotations,
              {
                quotation_id: uniqueId(),
                supplier,
                brand: item?.stock?.brands?.join("/ "),
                quantity: item?.quantity,
                discount_rate: supplier?.discount_rate || 0,
                terms: 30,
              },
            ];

            arr[index]["quotations"] = quotations;
          });
          setState((prevState) => {
            return {
              ...prevState,
              suppliers: [...(prevState?.suppliers || []), supplier],
              items,
            };
          });
        }}
        ref={supplierFormModal}
      />

      <StockFormModal
        setField={(stock) => {
          setItem((prevState) => ({
            ...prevState,
            stock,
          }));
        }}
        ref={stockFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* Start of Advance Search */}
      {hasAccess({
        auth,
        access: ACCESS_ADVANCE_SEARCH,
        location,
      }) && (
        <Row>
          <Col span={24} className="m-b-1">
            <Collapse>
              <Panel header="Advance Search" key="1">
                <PageHeader
                  backIcon={false}
                  style={{
                    border: "1px solid rgb(235, 237, 240)",
                  }}
                  onBack={() => null}
                  title="Advance Filter"
                  subTitle="Enter appropriate data to filter records"
                >
                  <div className="or-slip-form">
                    <Row>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Date"
                          name="period_covered"
                          value={search_state.period_covered}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              period_covered: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="RS No."
                          name="requisition_slip_no"
                          error={errors.requisition_slip_no}
                          formItemLayout={smallFormItemLayout}
                          value={search_state.requisition_slip_no}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Supplier"
                          value={search_state.supplier?.name}
                          onSearch={(value) =>
                            onSupplierSearch({ value, options, setOptions })
                          }
                          error={errors.supplier}
                          onChange={(index) => {
                            const supplier = options.suppliers[index];

                            setSearchState((prevState) => ({
                              ...prevState,
                              supplier,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.suppliers}
                          column="name"
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Status"
                          name="approval_status"
                          value={search_state.approval_status}
                          onChange={(value) => {
                            onChange({
                              key: "approval_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors.approval_status}
                          formItemLayout={smallFormItemLayout}
                          options={[
                            APPROVED_FOR_QUOTE,
                            PURCHASE_ORDER_GENERATED,
                            COMPARATIVE_CLOSED,
                            CANCELLED,
                          ]}
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="PRN"
                          name="prq_no"
                          error={errors.prq_no}
                          formItemLayout={smallFormItemLayout}
                          value={search_state.prq_no}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Item"
                          value={search_state.stock?.name}
                          onSearch={(value) =>
                            onStockSearch({ value, options, setOptions })
                          }
                          onChange={(index) => {
                            const stock = options.stocks[index];
                            setSearchState((prevState) => ({
                              ...prevState,
                              stock,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.stocks}
                          column="display_name"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Alert Status"
                          name="alert_status"
                          value={search_state.alert_status}
                          onChange={(value) => {
                            onChange({
                              key: "alert_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors.alert_status}
                          formItemLayout={smallFormItemLayout}
                          options={["Alert", "Seen", "Replied"]}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <Row>
                          <Col offset={8} span={12}>
                            <Button
                              type="info"
                              size="large"
                              icon={<SearchOutlined />}
                              onClick={() => {
                                onSearch({
                                  page: 1,
                                  search_keyword,
                                  url: "/api/comparative-slips/",
                                  setRecords,
                                  setTotalRecords,
                                  setCurrentPage,
                                  setErrors,
                                  advance_search: search_state,
                                  setSearch,
                                });
                              }}
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                </PageHeader>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}
      {/* End of Advanced Search */}

      <div style={{ background: "#fff", padding: 24 }}>
        <div className="is-flex">
          <div className="module-title flex-1">{title}</div>
          <div>
            <span className="has-text-weight-bold">FA</span> - For Approval ;{" "}
            <span className="has-text-weight-bold">AFQ</span> - Approved for
            Quote ; <span className="has-text-weight-bold">POG</span> - Purchase
            Order Generated Quote ;{" "}
            {/* <span className="has-text-weight-bold">CC</span> - Comparative
            Closed ; */}
            <span className="has-text-weight-bold">C</span> - Cancelled
          </div>
        </div>
        <Divider />
        {!search ? (
          <Form
            onFinish={(values) => {
              if (state.suppliers.length <= 0) {
                message.error("Supplier(s) is required");
                return;
              }

              if (!eachCheckedQuotationHasPrice(state)) {
                message.error(
                  "Checked Items should have prices and quantity",
                  5
                );
                return;
              }

              onFinish({
                loading,
                onSubmit,
                state: {
                  ...state,
                  is_comparative: true,
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                setLoading,
                setSearch,
                cb: () => {
                  onSearch({
                    page: current_page,
                    search_keyword,
                    url: "/api/comparative-slips/",
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: { ...search_state },
                    setSearch,
                  });
                },
              });
            }}
            initialValues={initialValues}
          >
            {state[transaction_counter.key] && (
              <TextFieldGroup
                label={transaction_counter.label}
                value={state[transaction_counter.key]}
                error={errors.remarks}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <DatePickerFieldGroup
              disabled={
                state.comparative_slip_status?.approval_status !==
                APPROVED_FOR_QUOTE
              }
              label="Date"
              name="date"
              value={state.date}
              onChange={(value) => {
                onChange({
                  key: "date",
                  value: value,
                  setState,
                });
              }}
              error={errors.date}
              formItemLayout={formItemLayout}
            />

            {state._id && [
              <TextFieldGroup
                disabled={true}
                key="prq-no"
                label="PRN"
                value={state.prq_no}
                formItemLayout={formItemLayout}
                readOnly
              />,
            ]}

            {/* {state.suppliers?.length < 6 &&
              state.comparative_slip_status?.approval_status ===
                APPROVED_FOR_QUOTE && (
                <SelectFieldGroup
                  label="Supplier"
                  value={state.supplier?.name}
                  onSearch={(value) =>
                    onSupplierSearch({ value, options, setOptions })
                  }
                  onSelect={(index) => {
                    if (index >= 0) {
                      const supplier = options.accounts[index];

                      const s = state.suppliers.find(
                        (o) => o._id === supplier._id
                      );

                      if (isEmpty(s)) {
                        //also append items here with

                        setState((prevState) => {
                          let items = [...state.items];
                          items.forEach((item, index, arr) => {
                            let quotations = item?.quotations || [];
                            let brand = item.brand;

                            if (brand === "ALL") {
                              brand = item.stock.brand;
                            }

                            const remarks = item.remarks;

                            quotations = [
                              ...quotations,
                              {
                                quotation_id: uniqueId(),
                                supplier,
                                brand: item?.stock?.brands?.join("/ "),
                                quantity: item?.quantity,
                                discount_rate: supplier?.discount_rate || 0,
                                terms: 30,
                                remarks,
                              },
                            ];

                            arr[index]["quotations"] = quotations;
                          });

                          return {
                            ...prevState,
                            suppliers: [
                              ...(prevState?.suppliers || []),
                              supplier,
                            ],
                            items,
                          };
                        });
                      } else {
                        message.error("Supplier already exists");
                      }
                    }
                  }}
                  error={errors.supplier}
                  formItemLayout={formItemLayout}
                  data={options.accounts}
                  column="name"
                  onAddItem={() => supplierFormModal.current.open()}
                />
              )}

            <Row>
              <Col offset={4} span={20}>
                <Table
                  dataSource={addKeysToArray(state.suppliers || [])}
                  columns={suppliers_column}
                  pagination={false}
                />
              </Col>
            </Row> */}

            <Divider />

            <DatePickerFieldGroup
              disabled={true}
              label="Date Needed"
              name="date_needed"
              value={state.date_needed}
              onChange={(value) => {
                onChange({
                  key: "date_needed",
                  value: value,
                  setState,
                });
              }}
              error={errors.date}
              formItemLayout={formItemLayout}
            />

            <TextAreaGroup
              disabled
              label="PR Remarks"
              name="remarks"
              value={state.remarks}
              error={errors.remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />

            <TextAreaGroup
              label="Comparative Remarks"
              name="comparative_remarks"
              value={state.comparative_remarks}
              error={errors.comparative_remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
              onBlur={() => {
                axios
                  .post(
                    `/api/comparative-slips/${state._id}/comparative-remarks`,
                    {
                      comparative_remarks: state.comparative_remarks,
                    }
                  )
                  .then(() => {
                    message.success("Remarks Saved");
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }}
            />

            {state.comparative_slip_status && (
              <TextFieldGroup
                disabled={true}
                label="Status"
                name="status"
                value={`${state.comparative_slip_status.approval_status} / ${
                  state.comparative_slip_status.user.name
                } / ${moment(state.comparative_slip_status.datetime).format(
                  "MM/DD/YY hh:mm A"
                )}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("MM/DD/YY hh:mm A")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <div className="m-t-1">
              <table className="comparative-table table is-full-width">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Desc.</th>
                    <th>Qty</th>
                    <th>UOM</th>
                    <th>INV. QTY</th>
                  </tr>
                </thead>
                <tbody>
                  {addKeysToArray(state.items).map((item, item_index) => {
                    const record = { ...state.items[item_index] };

                    return [
                      <tr key="2" className="row-is-selected">
                        <td>
                          <div>{item?.last_purchase?.supplier?.name}</div>
                        </td>
                        <td>
                          <div>
                            {item?.last_purchase?.date &&
                              moment(item?.last_purchase?.date).format(
                                "MM/DD/YY"
                              )}{" "}
                            - ₱{numberFormat(item?.last_purchase?.price)}
                          </div>
                        </td>
                        <td>{numberFormat(item?.last_purchase?.quantity)}</td>
                        <td>{item?.last_purchase?.unit_of_measure?.unit}</td>
                        <td>{item?.last_purchase?.brand}</td>
                        <td>{item?.last_purchase?.unit?.name}</td>
                      </tr>,
                      <tr key="1" className="row-main">
                        <td>{item?.stock?.name}</td>
                        <td>{item?.stock?.description}</td>
                        <td>{item?.quantity}</td>
                        <td>
                          <div>{item?.stock?.unit_of_measure}</div>
                        </td>
                        <td>{item.inventory_quantity}</td>
                      </tr>,
                      <tr key="suppliers">
                        <td colSpan="6">
                          {state.suppliers?.length < 6 &&
                            state.comparative_slip_status?.approval_status ===
                              APPROVED_FOR_QUOTE && (
                              <SelectFieldGroup
                                label="Supplier"
                                value={state.supplier?.name}
                                onSearch={(value) =>
                                  onSupplierSearch({
                                    value,
                                    options,
                                    setOptions,
                                  })
                                }
                                onSelect={(index) => {
                                  if (index >= 0) {
                                    const supplier = options.accounts[index];
                                    //also append items here with

                                    setState((prevState) => {
                                      let items = [...state.items];
                                      let quotations = [...item.quotations];
                                      let brand = item.brand;

                                      if (brand === "ALL") {
                                        brand = item.stock.brand;
                                      }

                                      const remarks = item.remarks;

                                      quotations = [
                                        ...quotations,
                                        {
                                          quotation_id: uniqueId(),
                                          supplier,
                                          brand:
                                            item?.stock?.brands?.join("/ "),
                                          quantity: item?.quantity,
                                          discount_rate:
                                            supplier?.discount_rate || 0,
                                          terms: supplier.terms,
                                          remarks,
                                        },
                                      ];

                                      items[item_index] = {
                                        ...items[item_index],
                                        quotations,
                                      };

                                      return {
                                        ...prevState,
                                        suppliers: [
                                          ...(prevState?.suppliers || []),
                                          supplier,
                                        ],
                                        items,
                                      };
                                    });
                                  }
                                }}
                                error={errors.supplier}
                                data={options.accounts}
                                column="name"
                                onAddItem={() =>
                                  supplierFormModal.current.open()
                                }
                              />
                            )}
                        </td>
                      </tr>,
                      <tr key="details">
                        <td colSpan="6">
                          <table className="is-full-width">
                            <thead>
                              <tr>
                                <td></td>
                                <td>Supplier</td>
                                <td>Qty</td>

                                <td>Price</td>
                                <td>Disc(%)</td>
                                <td>Terms</td>
                                <td>Net Price</td>
                                <td>Net Amount</td>
                                <td>&nbsp;</td>
                              </tr>
                            </thead>
                            <tbody>
                              {(item?.quotations || []).map(
                                (quotation, quotation_index) => {
                                  return [
                                    <tr key={`1-${quotation_index}`}>
                                      <td rowSpan={2}>
                                        <Checkbox
                                          disabled={
                                            state?.comparative_slip_status
                                              ?.approval_status !==
                                              APPROVED_FOR_QUOTE ||
                                            item.is_generated ||
                                            false
                                          }
                                          name="is_selected"
                                          checked={
                                            quotation?.is_selected || false
                                          }
                                          onChange={(e) => {
                                            const value = e.target.checked;

                                            const items = [...state.items];

                                            let quotations = [
                                              ...item.quotations,
                                            ];

                                            quotations[quotation_index] = {
                                              ...quotations[quotation_index],
                                              [e.target.name]: value,
                                            };

                                            items[item_index] = {
                                              ...items[item_index],
                                              quotations,
                                            };

                                            setState((prevState) => {
                                              return {
                                                ...prevState,
                                                items,
                                              };
                                            });
                                          }}
                                        />
                                      </td>
                                      <td rowSpan={2}>
                                        <Row>
                                          <Col span={20}>
                                            {quotation?.supplier?.name}{" "}
                                          </Col>
                                          <Col span={2}>
                                            <i
                                              className="fas fa-plus-circle"
                                              onClick={() => {
                                                if (
                                                  window.confirm(
                                                    "Would you like to add another quote for the same supplier?"
                                                  )
                                                ) {
                                                  const items = [
                                                    ...state.items,
                                                  ];
                                                  let quotations =
                                                    items?.[item_index]
                                                      ?.quotations || [];

                                                  quotations.splice(
                                                    quotation_index + 1,
                                                    0,
                                                    {
                                                      ...quotations[
                                                        quotation_index
                                                      ],
                                                      brand: "",
                                                    }
                                                  );

                                                  items[item_index] = {
                                                    ...items[item_index],
                                                    quotations,
                                                  };

                                                  setState((prevState) => {
                                                    return {
                                                      ...prevState,
                                                      items,
                                                    };
                                                  });
                                                }
                                              }}
                                            />
                                          </Col>
                                          <Col span={2}>
                                            <span>
                                              {state.comparative_slip_status
                                                ?.approval_status ===
                                                APPROVED_FOR_QUOTE && (
                                                <DeleteOutlined
                                                  onClick={() => {
                                                    let items = [
                                                      ...state.items,
                                                    ];
                                                    let quotations = [
                                                      ...item.quotations,
                                                    ];
                                                    let suppliers = [
                                                      ...(state.supplier || []),
                                                    ];

                                                    suppliers =
                                                      suppliers.filter(
                                                        (supplier) => {
                                                          return (
                                                            supplier?._id !==
                                                            quotations[
                                                              quotation_index
                                                            ].supplier?._id
                                                          );
                                                        }
                                                      );

                                                    quotations.splice(
                                                      quotation_index,
                                                      1
                                                    );

                                                    items[item_index] = {
                                                      ...items[item_index],
                                                      quotations,
                                                    };

                                                    setState((prevState) => ({
                                                      ...prevState,
                                                      items,
                                                      suppliers,
                                                    }));
                                                  }}
                                                />
                                              )}
                                            </span>
                                          </Col>
                                        </Row>
                                      </td>
                                      <td style={{ width: "100px" }}>
                                        <Input
                                          disabled={
                                            state?.comparative_slip_status
                                              ?.approval_status !==
                                              APPROVED_FOR_QUOTE ||
                                            item.is_generated ||
                                            false
                                          }
                                          autoComplete="off"
                                          type="number"
                                          step="0.01"
                                          value={quotation?.quantity}
                                          name="quantity"
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            const items = [...state.items];

                                            let quotations = [
                                              ...item.quotations,
                                            ];

                                            quotations[quotation_index] = {
                                              ...quotations[quotation_index],
                                              [e.target.name]: value,
                                            };

                                            items[item_index] = {
                                              ...items[item_index],
                                              quotations,
                                            };

                                            setState((prevState) => {
                                              return {
                                                ...prevState,
                                                items,
                                              };
                                            });
                                          }}
                                        />
                                      </td>

                                      <td style={{ width: "150px" }}>
                                        <Input
                                          className={classnames({
                                            "border-red":
                                              quotation.is_selected &&
                                              isEmpty(quotation.price),
                                          })}
                                          disabled={
                                            state?.comparative_slip_status
                                              ?.approval_status !==
                                              APPROVED_FOR_QUOTE ||
                                            item.is_generated ||
                                            false
                                          }
                                          autoComplete="off"
                                          type="number"
                                          step="0.01"
                                          value={quotation?.price}
                                          name="price"
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            const items = [...state.items];

                                            let quotations = [
                                              ...item.quotations,
                                            ];

                                            quotations[quotation_index] = {
                                              ...quotations[quotation_index],
                                              [e.target.name]: value,
                                            };

                                            items[item_index] = {
                                              ...items[item_index],
                                              quotations,
                                            };

                                            setState((prevState) => {
                                              return {
                                                ...prevState,
                                                items,
                                              };
                                            });
                                          }}
                                        />
                                      </td>

                                      <td style={{ width: "100px" }}>
                                        <Input
                                          disabled={
                                            state?.comparative_slip_status
                                              ?.approval_status !==
                                              APPROVED_FOR_QUOTE ||
                                            item.is_generated ||
                                            false
                                          }
                                          autoComplete="off"
                                          type="number"
                                          step="0.01"
                                          value={quotation?.discount_rate}
                                          name="discount_rate"
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            const items = [...state.items];

                                            let quotations = [
                                              ...item.quotations,
                                            ];

                                            quotations[quotation_index] = {
                                              ...quotations[quotation_index],
                                              [e.target.name]: value,
                                            };

                                            items[item_index] = {
                                              ...items[item_index],
                                              quotations,
                                            };

                                            setState((prevState) => {
                                              return {
                                                ...prevState,
                                                items,
                                              };
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ width: "150px" }}>
                                        <Input
                                          disabled={
                                            state?.comparative_slip_status
                                              ?.approval_status !==
                                              APPROVED_FOR_QUOTE ||
                                            item.is_generated ||
                                            false
                                          }
                                          autoComplete="off"
                                          type="number"
                                          step="0.01"
                                          value={quotation?.terms}
                                          name="terms"
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            const items = [...state.items];

                                            let quotations = [
                                              ...item.quotations,
                                            ];

                                            quotations[quotation_index] = {
                                              ...quotations[quotation_index],
                                              [e.target.name]: value,
                                            };

                                            items[item_index] = {
                                              ...items[item_index],
                                              quotations,
                                            };

                                            setState((prevState) => {
                                              return {
                                                ...prevState,
                                                items,
                                              };
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ width: "150px" }}>
                                        <Input
                                          className={classnames({
                                            "border-red":
                                              quotation.is_selected &&
                                              isEmpty(quotation.price),
                                          })}
                                          disabled
                                          type="number"
                                          value={round(
                                            quotation?.price *
                                              (1 -
                                                (quotation?.discount_rate ||
                                                  0) /
                                                  100)
                                          )}
                                        />
                                      </td>
                                      <td style={{ width: "150px" }}>
                                        <Input
                                          className={classnames({
                                            "border-red":
                                              quotation.is_selected &&
                                              isEmpty(quotation.price),
                                          })}
                                          disabled
                                          type="number"
                                          value={round(
                                            quotation?.quantity *
                                              quotation?.price *
                                              (1 -
                                                (quotation?.discount_rate ||
                                                  0) /
                                                  100)
                                          )}
                                        />
                                      </td>
                                    </tr>,
                                    <tr>
                                      <td colSpan={3}>
                                        <Input
                                          placeholder="Brand"
                                          disabled={
                                            state?.comparative_slip_status
                                              ?.approval_status !==
                                              APPROVED_FOR_QUOTE ||
                                            item.is_generated ||
                                            false
                                          }
                                          value={quotation?.brand}
                                          name="brand"
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            const items = [...state.items];

                                            let quotations = [
                                              ...item.quotations,
                                            ];

                                            quotations[quotation_index] = {
                                              ...quotations[quotation_index],
                                              [e.target.name]: value,
                                            };

                                            items[item_index] = {
                                              ...items[item_index],
                                              quotations,
                                            };

                                            setState((prevState) => {
                                              return {
                                                ...prevState,
                                                items,
                                              };
                                            });
                                          }}
                                        />
                                      </td>
                                      <td colSpan={3}>
                                        <Input
                                          placeholder="Remarks"
                                          disabled={
                                            state?.comparative_slip_status
                                              ?.approval_status !==
                                              APPROVED_FOR_QUOTE ||
                                            item.is_generated ||
                                            false
                                          }
                                          value={quotation?.remarks}
                                          name="remarks"
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            const items = [...state.items];

                                            let quotations = [
                                              ...item.quotations,
                                            ];

                                            quotations[quotation_index] = {
                                              ...quotations[quotation_index],
                                              [e.target.name]: value,
                                            };

                                            items[item_index] = {
                                              ...items[item_index],
                                              quotations,
                                            };

                                            setState((prevState) => {
                                              return {
                                                ...prevState,
                                                items,
                                              };
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>,
                                  ];
                                }
                              )}
                            </tbody>
                          </table>
                        </td>
                      </tr>,
                    ];
                  })}
                </tbody>
              </table>
            </div>

            <div className="m-t-1 has-text-centered is-italic is-error has-text-weight-bold">
              {eachItemHasPrice(state)
                ? null
                : "NOTE: EACH ITEM IS REQUIRED TO HAVE A PRICE IN EACH SUPPLIER"}
            </div>

            <ComparativeFormButtons
              state={state}
              auth={auth}
              loading={loading}
              url={url}
              transaction="comparative-slips"
              onDelete={onDelete}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              has_save={true}
              save_statuses={[APPROVED_FOR_QUOTE, PENDING]}
              onSearch={() => {
                onSearch({
                  page: current_page,
                  search_keyword,
                  url: "/api/comparative-slips/",
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                  setSearch,
                });
              }}
            />
          </Form>
        ) : (
          <div>
            {record_buttons}
            <Table
              dataSource={addKeysToArray(records)}
              rowKey={(record) => record._id}
              pagination={{
                position: ["topRight", "bottomRight"],
                current: current_page,
                defaultCurrent: current_page,
                onChange: (page) => {
                  onSearch({
                    page,
                    search_keyword,
                    url: "/api/comparative-slips/",
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: { ...search_state },
                    setSearch,
                  });
                },
                total: total_records,
                pageSize: 20,
              }}
              onRow={(record, index) => {
                return {
                  onClick: (e) => {
                    setState(initialValues);
                    setRowSelected(index);
                  },
                  onDoubleClick: (e) => {
                    setSearch(false);
                    //open a comparative form with the details of purchase requests

                    if (
                      record.comparative_slip_status?.approval_status ===
                      FOR_APPROVAL
                    ) {
                      // history.push(`/purchase-requests/${record._id}`);
                      return;
                    }

                    axios
                      .get(`/api/purchase-requests/${record._id}`)
                      .then((response) => {
                        if (response.data) {
                          edit({
                            record: {
                              _id: record._id,
                            },
                            setState,
                            setErrors,
                            setRecords,
                            url: "/api/purchase-requests/",
                            date_fields,
                            other_state: {
                              purchase_request: {
                                ...response.data,
                              },
                            },
                            setSearch,
                          });
                        }
                      })
                      .catch((err) =>
                        message.error(
                          "There was an error processing your request"
                        )
                      );
                  },
                };
              }}
              rowClassName={(record, index) => {
                if (row_selected === index) return "row-is-selected";
              }}
            >
              {/* <Column
                title="Status"
                dataIndex="po_generated"
                width={100}
                render={(value) => (value ? "GENERATED" : null)}
              /> */}
              <Column
                title="Status"
                dataIndex="comparative_slip_status"
                width={40}
                align="center"
                render={(comparative_slip_status) => {
                  return (
                    <span>
                      {(
                        comparative_slip_status?.approval_status?.match(
                          /\b(\w)/g
                        ) || []
                      )
                        ?.join("")
                        .toUpperCase()}
                    </span>
                  );
                }}
              />
              <Column
                title="PRN"
                dataIndex="prq_no"
                width={60}
                align="center"
              />
              <Column title="Project" dataIndex={["project", "name"]} />
              <Column
                title="Date"
                dataIndex="date"
                render={(date) => moment(date).format("MM/DD/YY")}
                width={80}
                align="center"
              />
              <Column
                title="Date Needed"
                dataIndex="date_needed"
                render={(date) => moment(date).format("MM/DD/YY")}
                align="center"
                width={80}
              />
              {[0, 1, 2].map((index) => (
                <Column
                  key={index}
                  align="center"
                  title={`Item ${index + 1}`}
                  render={(value, record) => {
                    return record?.items?.[index]?.stock?.name;
                  }}
                  width={200}
                />
              ))}
              <Column
                title="# of Suppliers"
                dataIndex="items"
                render={(items) =>
                  uniq(
                    flattenDeep(
                      items.map((o) => {
                        return o?.quotations
                          ?.filter((q) => q.price > 0)
                          ?.map((s) => s?.supplier?.name);
                      })
                    )
                  )?.length || 0
                }
                align="center"
                width={80}
              />
              {/* <Column
                title="Alert"
                render={(value, record) => (
                  <div className="has-text-centered">
                    {record.alert_status === "Alert" && (
                      <span className="red-dot "></span>
                    )}
                    {record.alert_status === "Replied" && (
                      <span className="red-dot blink-me"></span>
                    )}
                    {record.alert_status === "Seen" && (
                      <span className="gray-dot"></span>
                    )}
                  </div>
                )}
                align="center"
                width={80}
              /> */}
            </Table>

            {record_buttons}
          </div>
        )}
      </div>
    </Content>
  );
}
